import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

interface TooltipProps {
    content: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    content: null
  },
  setup(__props: any) {



const isVisible = ref(false);

const show = () => {
    isVisible.value = true;
};

const hide = () => {
    isVisible.value = false;
};

return { __sfc: true,isVisible, show, hide }
}

})